import {
  GraphQLLayoutService,
  RestLayoutService,
  constants,
} from '@sitecore-jss/sitecore-jss-react';
import config from '../temp/config';

type TFetchParams = {
  [param: string]: string | number | boolean;
  sc_apikey: string;
  sc_site: string;
  sc_lang: string;
  tracking: boolean;
}

export class ParameterizedRestLayoutService extends RestLayoutService {
  constructor(private config) {
    super(config);
  }

  protected getFetchParams = (language?: string): TFetchParams => {
    return {
      sc_apikey: this.config.apiKey,
      sc_site: this.config.siteName,
      sc_lang: language || '',
      tracking: this.config.tracking ?? true,
      ...this.config.extraQueryParams
    };
  };
}

export class LayoutServiceFactory {
  create(siteName, extraQueryParams) {
    return process.env.REACT_APP_FETCH_WITH === constants.FETCH_WITH.GRAPHQL
      ? new GraphQLLayoutService({
        endpoint: config.graphQLEndpoint,
        apiKey: config.sitecoreApiKey,
        siteName: config.jssAppName,
      })
      : new ParameterizedRestLayoutService({
        apiHost: config.sitecoreApiHost,
        apiKey: config.sitecoreApiKey,
        siteName: siteName,
        configurationName: 'jss',
        extraQueryParams
      });
  }
}

export const layoutServiceFactory = new LayoutServiceFactory();
